// eslint-disable-next-line
console.warn('luma.gl/addons is deprecated, please use @luma.gl/addons instead');
module.exports = require('@luma.gl/addons');
